import { type ReactNode } from 'react';
import { type HTMLMotionProps, type Transition } from 'framer-motion';
import * as S from './styled';

export type PinFrameProps = {
  /** Top offset (px) inside the positioning context */
  top?: number;
  /** Left offset (px) inside the positioning context */
  left?: number;
  /** Width (px) — scale transforms originate from the center of this box */
  width: number;
  /** Height (px) */
  height: number;
  children?: ReactNode;
  /** framer-motion props forwarded to the underlying motion.div */
  initial?: HTMLMotionProps<'div'>['initial'];
  animate?: HTMLMotionProps<'div'>['animate'];
  transition?: Transition;
  className?: string;
};

export const PinFrame = ({
  left = 0,
  top = 0,
  width,
  height,
  children,
  className,
  initial,
  animate,
  transition,
}: PinFrameProps) => (
  <S.Frame
    className={className}
    $left={left}
    $top={top}
    $width={width}
    $height={height}
    initial={initial}
    animate={animate}
    transition={transition}
  >
    {children}
  </S.Frame>
);
